// src/pages/EditAdPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { db, auth } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { updateAdInFirebase } from '../../components/PostAd/SubmitAd';

const EditAdPage = () => {
  const { adId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  useEffect(() => {
    const fetchAd = async () => {
      const docSnap = await getDoc(doc(db, 'listings', adId));
      if (docSnap.exists()) {
        const data = docSnap.data();
        
        // SECURITY CHECK: Ensure only the owner can edit
        if (data.userId !== auth.currentUser?.uid) {
          alert("Unauthorized access");
          navigate('/');
          return;
        }

        // Pre-fill the form with existing data
        reset({
          title: data.title,
          description: data.description,
          price: data.price
        });
      }
      setLoading(false);
    };
    fetchAd();
  }, [adId, reset, navigate]);

  const onSubmit = async (data) => {
    setIsSaving(true);
    try {
      await updateAdInFirebase(adId, {
        title: data.title,
        description: data.description,
        price: parseInt(data.price)
      });
      alert("Ad updated successfully!");
      navigate(`/ad/${adId}`);
    } catch (error) {
      alert("Failed to update ad");
    } finally {
      setIsSaving(false);
    }
  };

  if (loading) return <div className="loader-full">Loading Ad Details...</div>;

  return (
    <div className="post-ad-page">
      <div className="post-ad-container" style={{ textAlign: 'left' }}>
        <h2>Edit Listing</h2>
        <p>You can update the primary details of your ad here.</p>

        <form onSubmit={handleSubmit(onSubmit)} className="dynamic-form">
          <div className="form-group">
            <label>Ad Title *</label>
            <input 
                type="text" 
                {...register('title', { required: true, maxLength: 70 })} 
            />
            {errors.title && <span className="error">Required (Max 70 chars)</span>}
          </div>

          <div className="form-group">
            <label>Description *</label>
            <textarea 
                {...register('description', { required: true })} 
            />
            {errors.description && <span className="error">Description is required</span>}
          </div>

          <div className="form-group">
            <label>Price *</label>
            <div className="input-with-affix">
              <span>₹</span>
              <input 
                type="number" 
                {...register('price', { required: true })} 
              />
            </div>
            {errors.price && <span className="error">Price is required</span>}
          </div>

          <button type="submit" className="continue-btn" disabled={isSaving}>
            {isSaving ? "Saving Changes..." : "Update Ad"}
          </button>

          <button 
            type="button" 
            className="reset-btn" 
            style={{ width: '100%' }}
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditAdPage;